import { createSelector } from 'selectors'
import { getEditorConcreteComponent } from '../../selector'
import { dynamicTable } from './constant'

const getEditorDynamicTableContainer = () =>
	createSelector<HTMLElement>({ selector: dynamicTable.questionSettings.container })

const getTypeSelectComponents = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: dynamicTable.questionSettings.type }, true)

const getColumnSettingsSelectComponents = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: dynamicTable.questionSettings.setting }, true)

const getColumnSettingsSelectContainers = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: dynamicTable.questionSettings.settingContainer }, true)

const getImageSubsettingsSelectContainers = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: dynamicTable.questionSettings.imageSubsettings }, true)

export const getDynamicTableComponents = () => {
	const dynamicTableContainer = getEditorDynamicTableContainer()
	const typeSelects = getTypeSelectComponents(dynamicTableContainer)
	const settingSelects = getColumnSettingsSelectComponents(dynamicTableContainer)
	const settingSelectsContainers = getColumnSettingsSelectContainers(dynamicTableContainer)
	const imageSubsettingsContainers = getImageSubsettingsSelectContainers(dynamicTableContainer)

	const questionnaireSelect = getEditorConcreteComponent(dynamicTable.questionnaireSelect.select)
	const paginationSelect = getEditorConcreteComponent(dynamicTable.paginatorSelect.select)
	const showMoreSelect = getEditorConcreteComponent(dynamicTable.showMoreSelect.select)

	return {
		questionnaireSelect,
		typeSelects,
		settingSelects,
		settingSelectsContainers,
		paginationSelect,
		imageSubsettingsContainers,
		showMoreSelect,
	}
}
